import { render } from "./DialogShare.vue?vue&type=template&id=36593d34&scoped=true"
import script from "./DialogShare.vue?vue&type=script&lang=js"
export * from "./DialogShare.vue?vue&type=script&lang=js"

import "./DialogShare.vue?vue&type=style&index=0&id=36593d34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36593d34"]])

export default __exports__